import { ReactElement } from 'react'
import { useFormContext, useFormState, useWatch } from 'react-hook-form'
import { Stack } from '@mui/material'
import { TextField, UploadField } from '@ui/forms'

const FormFields = (): ReactElement => {
  const currentTitle = useWatch({ name: 'name' })
  const { setValue } = useFormContext()
  const { defaultValues } = useFormState()

  return (
    <Stack spacing={2}>
      <TextField name="name" placeholder="Name" />
      <UploadField
        name="file"
        accept={{
          'application/pdf': [],
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [],
        }}
        onSelect={file => {
          if (currentTitle === defaultValues?.name) {
            setValue('name', file.name)
          }
        }}
      />
    </Stack>
  )
}

export default FormFields
